import $ from 'jquery';
import StartView from '../views/StartView';
import Start from '../models/Start';
import svgPanZoom from 'svg-pan-zoom';
import App from '../app';
import { lang as _lang } from '~/data-utils';
import Events from '../events';
import { addStoreLabels } from '../map/store-labels';
import { addIcons } from '../map/store-icons';
import { addMap } from '../map/map';
import { isVisibleElement } from '../util';

function start(context){
  var params = Start.init(context);
  StartView.render(params);
  bindEvents(params);
  setMoreLinkVisibility();
  App.removeStoredData('searchdata', 'all');
  App.setTimerTimeouts(15000, context.resetToStartTimeout * 1000);
  updateLangAttribute(params.currentLang);

  Events.addEventListener('language:change', event => {
    const { currentLang } = Start.getData();
    if(currentLang != _lang()) {
      updateLangAttribute(event.detail);
      Start.refreshLanguage();
      refresh();
    }
  });
}
function refresh(){
  var params = Start.getData();
  StartView.render(params);
  bindEvents(params);
  setMoreLinkVisibility();
}

function bindEvents(params){

  // Skip if map is hidden with styles
  if (isVisibleElement(document.getElementById('svgmap'))) {
    addMap('#svgmap', params.scimddata.imdFloors, params.storedata, params.imd.floorId, '', params.imddata.rotation);
    addStoreLabels('#svgmap__container', '#stores > *', params.storedata, params.imddata.rotation, params.scid);
    addIcons('#svgmap__container', 'icons', params.startNodes, params.imddata.rotation);

    const panZoom = svgPanZoom('#svgmap', {
      center: false,
      fit: false
    });

    panZoom.zoom(1);

    const customPan = getNewCoordinates({x: params.imddata.x, y: params.imddata.y}, params.imddata.rotation);
    const newCustomPan = {x: $('#svgmap').width()/2 - customPan.x, y: $('#svgmap').height()/2 - customPan.y};
    panZoom.pan({x: newCustomPan.x, y: newCustomPan.y - 50});
    panZoom.zoom(1.5);
  }

  $('.more-popup').hide();
  $('.more-popup-overlay').hide();
  $('.mainmenu__list__item').on('click', function(){
    Start.goTo(this.id);
  });
  $('.lang-select__lang').on('click', function(){
    if(this.id != params.currentLang){
      App.selectLanguage(this.id);
    }
  });
  $('.main-minor-link--more').on('click', function(){
    $('.more-popup').toggle();
    $('.more-popup-overlay').toggle();
  });
  $('.more-popup .close').on('click', function(){
    $('.more-popup').hide();
    $('.more-popup-overlay').hide();
  });
  $('.more-popup .item').on('click', function(e){
    e.stopPropagation();
  });
  $('.more-popup-overlay').on('click', function(e){
    $('.more-popup').hide();
    $('.more-popup-overlay').toggle();
    e.stopPropagation();
  });
  $('.main-major-link, .main-minor-link').on('click', function(){
    if (this.id) {
      Start.goTo(this.id);
    }
  });
  $('.search__element').on('click', function(){
    Start.goTo('#search');
  });

  $('.item').on('click', function() {
    Start.goToThirdPartyLink(Number(this.dataset.linkindex));
  });
}

function setMoreLinkVisibility() {
  if(App.isOnline()) {
    $('.main-minor-link--more').show();
  } else {
    $('.main-minor-link--more').hide();
  }
}

function getNewCoordinates(point, angle) {

  var radians = (Math.PI / 180) * angle,
      cos = Math.cos(radians),
      sin = Math.sin(radians),
      ny = point.y*cos + point.x*sin,
      nx = -point.y*sin + point.x*cos;


  return {x: nx, y: ny};
}

const updateLangAttribute = lang =>
  document.documentElement.setAttribute('lang', lang);

export default {
  start,
  refresh
};
